<template>
	<div >
		<!-- 关联 -->
		<div class="workihead FlexBetween">
			<div></div>
			<div class="addarea ">
				<el-dropdown>
					<div class="addbtn Flexalign">
						<i class="el-icon-plus"></i>
						添加
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item :command="1" @click.native="recyclick(1)" v-if="currentRote == 1">需求</el-dropdown-item>
						<el-dropdown-item :command="2" @click.native="recyclick(2)" v-if="currentRote == 2">任务</el-dropdown-item>
						<el-dropdown-item :command="3" @click.native="recyclick(3)" v-if="currentRote == 3">问题</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
		
		<div class="workiaddlist">
			<div class="add_item Flexalign" v-for="(item1, index1) in addlist">
				<div class="type_box FlexRow">
					<div class="icon">
						<img src="../../image/icon1.png" alt="" v-if="item1.type == 1">
						<img src="../../image/icon2.png" alt="" v-else-if="item1.type == 2">
						<img src="../../image/icon3.png" alt="" v-else-if="item1.type == 3">
						<img src="../../image/icon4.png" alt="" v-else-if="item1.type == 4">
					</div>
					<div class="txt">
						{{item1.type_txt || ''}}
					</div>
				</div>
				
				<div class="search_create_box">
					<div class="search_input Flexalign">
					
						<el-input v-model="item1.content_name"  :disabled="item1.content_id != ''"
						@focus="searchFocus($event, index1)"
						@blur="searchBlur($event, index1)" 
						@input="search_change($event, index1)"></el-input>
						<div v-show="item1.content_name" class="dclearable" @click="dclearable(index1)">
							<i class="el-icon-close"></i>
						</div>
						<div class="dropdown" :class="{'isdown': item1.isdown}">
							<i class="el-icon-arrow-down"></i>
						</div>
					</div>
					
					
					<div class="search_resbox" :id="'select' + (index1 + 1)" v-show="item1.isdown">
						<div class="res_item FlexBetween" 
						@click="setSearchVal(index1, dval)"
						:class="{'isActive': dval.isActive}" 
						v-for="(dval, dindex) in item1.downlist">
							<div class="Flexalign">
								<div class="code" v-if="dval.code_txt">
									{{dval.code_txt || ''}}
								</div>
								<div class="title Singlerow">
									{{dval.title || ''}}
								</div>
							</div>
							
							<div class="type_txt">
								{{dval.type_txt || ''}}
							</div>
						</div>
						<div class="nodatxt" v-if="item1.downlist.length == 0">
							暂无数据
						</div>
						
					</div>
				</div>
				
				<div class="member_select">
					<el-select  placeholder="负责人" v-model="item1.member_id">
						<el-option v-for="val in memberlist"  :label="val.name"
							:value="val.member_id">
							<span class="custom-option">
								<span class="checkbox"></span> 
								{{ val.name }}
							</span>
						</el-option>
					</el-select>
				</div>
				
				<div class="operate_box Flexalign">
					<el-button class="create" v-show="item1.isnew" @click="newclick(index1)">
						 新建
					</el-button> 
					<el-button class="create" v-show="item1.isadd" @click="craddclick(index1)">
						 添加
					</el-button>
					<el-button class="close" @click="closeclick(index1)">
						 取消
					</el-button>
				</div>				
				
			</div>
		</div>
		
		
		<div class="worki_content">
			<div class="worki_line Flexalign" v-for="(item1, index1) in contentlist">
				<div class="detail_links Flexalign">
					<div class="icon">
						<img src="../../image/icon1.png" alt="" v-if="item1.type == 1">
						<img src="../../image/icon2.png" alt="" v-else-if="item1.type == 2">
						<img src="../../image/icon3.png" alt="" v-else-if="item1.type == 3">
						<img src="../../image/icon4.png" alt="" v-else-if="item1.type == 4">
					</div>
					<div class="links_txt FlexRow">
						{{item1.project_demand_code}}
					</div>
				</div>
				<div class="worki_val">
					<div class="ctxt">
						{{item1.title || ''}}
					</div>
				</div>
				<div class="member_area Flexalign" v-if="item1.member_name">
					<div class="icon_box FlexRow">
						<i class="iconfont icon-a-lujing131"></i>
					</div>
					<div class="txt">
						{{item1.member_name || ''}}
					</div>
				</div>
				
				<div class="cancelbtn">
					<el-dropdown>
						<div class="addbtn Flexalign">
							<i class="el-icon-more"></i>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="1" @click.native="cancelbtn(1, item1)" >取消关联</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
			<div class="nodatxt" v-if="contentlist.length == 0">
				暂无数据
			</div>
		</div>
		
		
	</div> 
</template>

<script>
	import {
		deepEqual,
		deepStrs,
		fn_retjson,
		retJSONArr,
		Basics_field,
	} from "network/defaults";
	var that;
	import {
		
		get_project_demand_code,
		get_project_damand_status,
		get_project_damand_level,
		add_project_damand,
		get_project_damand_list,
		del_project_damand,
		get_project_damand_details,
		update_project_damand,
		get_project_damand_son,
		update_project_damand_field,
		updata_project_field,
	} from "../../js/project.js";
	import {
		
		get_module_comtomer,
		get_customer_form_id,
	} from "network/hk_customer";
	export default {
		name: 'assocarea',
		props: {
			rote: {  // 1.需求  2.任务  3.问题
				type: String,
				default: '1,2,3'
			},
			isshow: {
				type: Boolean,
				default: false,
			},
			types: {
				type: Number,
				default: 1,
			},
			currentRote: {
				type: Number,
				default: 1,
			},
			content_id: {
				type: Number,
				default: 0,
			},
			project_id: {
				type: Number,
				default: 0,
			},
			
			memberlist: {
				type: Array,
				default: ()=>{
					return []
				},
			},
			infos:{
				type: Object | String,
				default: '',
			},
			
		},
		components: {
			
		},
		watch: {
			isshow(){
				this.contentlist = []
				if(this.isshow) {
					
					this.fn_getdamandStatus()
					this.fn_getdamandLevel()
					this.cleardata() 
				}
			},
			
		},
		created(){
			this.setdatas()
		},
		methods: {
			
			setdatas(){
				if(this.currentRote == 1) {  // 需求
					this.c_projcet_div_id = 3
				}
				else if(this.currentRote == 2) {  // 任务
					this.c_projcet_div_id = 5
				}
				else if(this.currentRote == 3) {  // 问题
					this.c_projcet_div_id = 4
				}
			},
			
			// 需求级别
			fn_getdamandLevel() {
				if(this.Levellist.length > 0) return
				get_project_damand_level().then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result || []
						for (let item of obj) {
							item.id = item.level_id
						}
						this.Levellist = obj
					}
				})
			},
			
			// 需求状态
			fn_getdamandStatus() {
				if(this.Statuslist.length > 0) return
				get_project_damand_status().then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result || []
						for (let item of obj) {
							item.id = item.status_id
						}
						this.Statuslist = obj
					}
				})
			},
			// 取消
			closeclick(index1){
				this.addlist.splice(index1, 1)
			},
			// 搜索框聚焦
			searchFocus(e, index){
				let obj = this.addlist[index]
				let search_name = obj.content_name || '';
				this.curselectid = `#select${index + 1}`
				this.cursearch_name = search_name 
				this.cursearch_Index = index 
				clearTimeout(this.FocusTimer);
				this.addlist[index].downlist = []
				this.FocusTimer = setTimeout(() => {
					this.getsubclass(search_name, index); // 定时器生效时执行的方法
					this.fn_startatu()
				}, 500);
			},
			fn_startatu() {
				if(this.curselectid) {
					// 首次加载页面的时候给列表元素添加 滚动的事件监听
					this.filelists = document.querySelector(this.curselectid)
					document.querySelector(this.curselectid).addEventListener('scroll', this.hanleScroll, true)
				}
			},
			hanleScroll() {
				this.scrollBottom = (document.querySelector(this.curselectid).scrollHeight - document.querySelector(
					this.curselectid).clientHeight) - document.querySelector(this.curselectid).scrollTop
			},
			// 搜索框失焦
			searchBlur(e, index){
				clearTimeout(this.BlurTimer);
				this.clearpage()
				this.BlurTimer = setTimeout(() => {
					if(this.addlist[index]) {
						this.addlist[index].isdown = false
						let content_id = this.addlist[index].content_id
						this.addlist[index].downlist = this.addlist[index].downlist.filter(v=>v.project_demand_id == content_id)
					}
				}, 500)
			},
			// 搜索内容改变
			search_change(e, index){
				clearTimeout(this.changeTimer);
				this.addlist[index].downlist = []
				this.changeTimer = setTimeout(() => {
					this.clearpage()
					this.getsubclass(e,index); // 
				}, 500);
			},
			clearpage(){
				this.selectobj.pagesize = 30
				this.selectobj.page = 1
				this.selectobj.last_page = 0
			},
			// 清空当前搜索和选择内容
			dclearable(index){
				let obj = this.addlist[index]
				obj.content_name = ''
				obj.content_id = ''
				obj.isnew = true
				obj.isadd = false
			},
			// 搜索结果点击选择
			setSearchVal(index1, dval){
				if(dval) {
					let obj = this.addlist[index1]
					let content_id = dval.project_demand_id
					obj.content_name = dval.title
					obj.content_id = content_id
					
					obj.isnew = false
					obj.isadd = true
				}
			},
			// 输入名称搜索数据
			getsubclass(search_name, index){
				let obj = this.addlist[index]
				let data = {
					sort_type: 1, 
					pagesize: this.selectobj.pagesize,
					page: this.selectobj.page,
					type: obj.type,
					class_type: 0,
					search_type: 1,
				};
				if (search_name) {
					data.search_name = (search_name + '').trim();
				}
				if(!this.$clickgate()) return;
				this.getdatasList(data, index)
			},
			recyclick(flag){
				if(this.addlist.length == 0) {
					let txtarr = ['需求','任务','问题',]
					let type_txt = txtarr[flag - 1]
					let member_id = localStorage.member_id * 1;
					let newEle = {
						member_id,
						type: flag,
						type_txt,
						content_name: '',
						content_id: '',
						isdown: false,
						downlist: [],
						isnew: true,
						isadd: false,
					}
					this.addlist.push(newEle)
				}
			},
			
			
			Judgmentype(){
				let data = {
					sort_type: 1, 
					pagesize: 999, 
					page: 1,
					class_type: 0,		
					type: this.currentRote ,
				};
				
				if(this.types == 1) {
					data.project_id = this.project_id
					this.getdatasList(data)
				}
				else {
					data.project_demand_id = this.content_id
					this.getDamand_son(data)
				}
				
				
			},
			
			getDamand_son(data){
				get_project_damand_son(data).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result || []
						this.contentlist = obj
					}
				})
			},
			// 获取列表
			getdatasList(data, index) {
				get_project_damand_list(data).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result.data || []
						if(index != undefined) {
							for(let item of obj) {
								item.isActive = false
								item.type_txt = this.typelist[item.type - 1]
								item.code_txt = item.project_demand_code || ''
							}
							let arr = []
							if(this.types == 1){
								arr = obj.filter(v=>v.project_id != this.content_id)
							}
							else if(this.types == 2){
								arr = obj.filter(v=>v.project_demand_id != this.content_id && v.project_demand_pid != this.content_id && v.project_demand_id != this.infos.project_demand_pid)
							}
							this.addlist[index].downlist = arr
							this.addlist[index].isdown = true
							
							this.selectobj.last_page = res.result.last_page || 0
						}
						else {
							
							this.contentlist = obj
						}
					}
				});
			},
			cancelbtn(flag, item1){  // 取消 关联
				if(flag == 1) {
					let fd = new FormData();
					fd.append('project_demand_id', item1.project_demand_id);
					fd.append('value', 0);
					fd.append('edit_data', '');
					fd.append('member_id', item1.member_id);
					fd.append('field', 'project_id');
					
					update_project_damand_field(fd).then((res)=>{
						if (this.$handlereq(res)) {
							this.$alertMess('更新成功')
							this.cleardata()
						}
					})
				}
			},
			craddclick(index1){  // 添加 
				let obj =  this.addlist[index1]
				this.currentclickObj = obj
				let fd = new FormData();
				fd.append('project_demand_id', obj.content_id);
				fd.append('value', this.content_id);
				fd.append('edit_data', '');
				fd.append('member_id', obj.member_id);
				fd.append('field', 'project_id');
				
				update_project_damand_field(fd).then((res)=>{
					if (this.$handlereq(res)) {
						this.$alertMess('更新成功')
						this.cleardata()
					}
				})
				
				
			}, 
			newclick(index1){ // 新建
				let obj = this.addlist[index1]
				let name = (obj.content_name + '').trim()
				console.log(name,'name')
				if(!name){
					this.$alertMess('请填写名称名','error')
				}
				else {
					this.currentclickObj = obj
					this.field_create = []
					this.fn_getProject_Code()
				}
			},
			
		
			
			// "x编号"
			fn_getProject_Code() {
				get_project_demand_code().then((res) => {
					if (this.$handlereq(res)) {
						let resobj = res.result ? res.result.project_demand_code : '';
						this.projectCode = resobj
						this.getmodulelist(this.c_projcet_div_id)
					}
				})
			},
			// 获取所有字段模板 1级模板
			getmodulelist(projcet_div_id) {
				get_module_comtomer(projcet_div_id).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result || []
						if (obj.length) {
							for (let item of obj) {
								item.id = item.form_id
							}
						};
						// 新建默认选择系统模板 使用 form_id 2级模板
						let form_id = obj[0].form_id || '';
						// 2级模板id
						this.currentMod_id = form_id;
						this.getmoduleField(projcet_div_id, this.currentMod_id)
					}
				});
			},
			// 获取当前选用模板下的所有字段信息  获取2级模板
			getmoduleField(projcet_div_id, form_id) {
				get_customer_form_id(form_id, 1, projcet_div_id).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result || [];
						// 赋值改动字段
						if(this.currentRote == 1) {
							this.handle_xuqiu(obj)
						}
						else if(this.currentRote == 2) {
							this.handle_renwu(obj)
						}
						else if(this.currentRote == 3) {
							this.handle_wenti(obj)
						}
						
						this.field_create = obj
						this.fnCreateSave()
					}
				})
			},
			
			// field_id  content  field_sign  field_type
			// 需求   
			handle_xuqiu(data) {
				for (let item of data) {
					let field = item.field || item.field_sign ;
					if (field == '需求编号') {
						item.content = this.projectCode
					} 
					else if (field == '需求开始日期' || field == '计划完成日期') {
						item.content = Date.parse(new Date())
					} 
					else if (field == '需求级别') {
						item.content = this.Levellist[0] ? this.Levellist[0].id : '';
					} else if (field == '需求状态') {
						item.content = this.Statuslist[0] ? this.Statuslist[0].id : '';
					}
					else if (field == '需求类型') {
						item.content = 1
					} 
					else if (field == '需求项目') {
						item.field_type = 11
						item.content = this.project_id
						console.log(this.project_id,'this.project_id')
					} 
					if (field == '需求名称') {
						if(this.currentclickObj && this.currentclickObj.content_name) {
							item.content = this.currentclickObj.content_name
						}
					} 
					else if (field == "负责人") {
						if(this.currentclickObj && this.currentclickObj.member_id) {
							item.content = this.currentclickObj.member_id
						}
						else{
							item.content = localStorage.member_id * 1;
						}
						
					} else if (field == "协同人") {
						item.content = []
					} else if (field == '需求模板') { // 模板
						item.field_type = 18
						item.content = this.currentMod_id
					}
				}
			},
			// 任务
			handle_renwu(data) {
				for (let item of data) {
					let field = item.field || item.field_sign ;
					if (field == '任务编号') {
						item.content = this.projectCode
					} 
					else if (field == '任务开始日期' || field == '计划完成日期') {
						item.content = Date.parse(new Date())
					} 
					else if (field == '任务级别') {
						item.content = this.Levellist[0] ? this.Levellist[0].id : '';
					} else if (field == '任务状态') {
						item.content = this.Statuslist[0] ? this.Statuslist[0].id : '';
					}
					else if (field == '任务类型') {
						item.content = 2
					} 
					else if (field == '任务项目') {
						item.field_type = 11
						item.content = this.project_id
					} 
					if (field == '任务名称') {
						if(this.currentclickObj && this.currentclickObj.content_name) {
							item.content = this.currentclickObj.content_name
						}
					} 
					else if (field == "负责人") {
						if(this.currentclickObj && this.currentclickObj.member_id) {
							item.content = this.currentclickObj.member_id
						}
						else{
							item.content = localStorage.member_id * 1;
						}
						
					} else if (field == "协同人") {
						item.content = []
					} else if (field == '任务模板') { // 模板
						item.field_type = 18
						item.content = this.currentMod_id
					}
				}
			},
			// 问题
			handle_wenti(data) {
				for (let item of data) {
					let field = item.field || item.field_sign ;
					if (field == '问题编号') {
						item.content = this.projectCode
					} 
					else if (field == '问题开始日期' || field == '计划完成日期') {
						item.content = Date.parse(new Date())
					} 
					else if (field == '问题级别') {
						item.content = this.Levellist[0] ? this.Levellist[0].id : '';
					} 
					else if (field == '问题状态') {
						item.content = this.Statuslist[0] ? this.Statuslist[0].id : '';
					}
					else if (field == '问题类型') {
						item.content = 3
					} 
					else if (field == '问题项目') {
						item.field_type = 11
						item.content = this.project_id
					} 
					if (field == '问题名称') {
						if(this.currentclickObj && this.currentclickObj.content_name) {
							item.content = this.currentclickObj.content_name
						}
					} 
					else if (field == "负责人") {
						if(this.currentclickObj && this.currentclickObj.member_id) {
							item.content = this.currentclickObj.member_id
						}
						else{
							item.content = localStorage.member_id * 1;
						}
					} else if (field == "协同人") {
						item.content = []
					} else if (field == '问题模板') { // 模板
						item.field_type = 18
						item.content = this.currentMod_id
					}
				}
			},
			// 新建,编辑保存
			fnCreateSave() {
				let uarr = []
				let tsarr = []
				if(this.currentRote == 1) {
					uarr = this.Referencearr1
					tsarr = this.ReferenceTime1
				}
				else if(this.currentRote == 2) {
					uarr = this.Referencearr2
					tsarr = this.ReferenceTime2
				}
				else if(this.currentRote == 3) {
					uarr = this.Referencearr3
					tsarr = this.ReferenceTime3
				}
				let resdata = this.fn_Savedatas(uarr, tsarr)
				let currobj = this.field_create;
				let newArr = Basics_field(currobj);
				if(this.types != 1) {
					resdata.append("project_demand_pid", this.content_id);
				}
				
				resdata.append("project_demand_info", JSON.stringify(newArr));
				add_project_damand(resdata).then((res) => {
					if (this.$handlereq(res)) {
						this.$alertMess("新建成功", "success");
						this.cleardata()
					}
				});
				
			},
			cleardata(){
				this.currentMod_id = ''
				this.field_create = []
				this.projectCode = ''
				this.currentclickObj = ''
				this.Judgmentype()
				this.addlist = []
			},
			// 保存数据处理
			fn_Savedatas(uarr, tsarr) {
				let fd = new FormData();
				fd.append('type', this.currentRote);
				for (let i = 0; i < uarr.length; i++) {
					let {
						name,
						key
					} = uarr[i]
					let res_ = this.findfont(name)
					if(res_) {
						fd.append(key, res_);
					}
				}
				for (let i = 0; i < tsarr.length; i++) {
					let {
						name,
						key 
					} = tsarr[i]
					let res_ = this.findfont(name)
					if (res_) {
						let len = (res_ + "").length;
						let time_Res = len > 10 ? ((res_ + '').slice(0, 10) * 1) : res_;
						fd.append(key, time_Res);
					}
				}
				// 
				let assistant = this.findfont("协同人") || '';
				if (assistant && assistant.length) {
					// 	否	string	协同人id	逗号间隔 加 逗号
					fd.append("assistant_member_id", assistant.join(",") + ",");
				}
				return fd;
			},
			
			findfont(field) {
				if (this.field_create.length) {
					let index = this.field_create.findIndex((v) => v.field_sign == field || v.field == field);
					if (index != -1) {
						return this.field_create[index].content;
					} else {
						return "";
					}
				}
			},
			
			
		},
		data() {
			return {
				//
				FocusTimer: null,
				changeTimer: null,
				BlurTimer: null,
				
				scrollBottom: 0,
				
				filelists: null,
				curselectid:'',
				cursearch_name: '',
				cursearch_Index: -1,
				selectobj: { 
					pagesize: 30,
					page: 1,
					last_page: 0,
				},
				// 
				typelist: [
					'需求','任务','问题',
				],
				contentlist: [],
				
				field_create: [],
				
				projectCode: '',
				
				c_projcet_div_id: 3,
			
				currentMod_id: '',
				
				currentclickObj: '',
			
				addlist: [],
				Statuslist: [],
				Levellist: [],
				TimeId: null,
				
				// 需求
				Referencearr1: [
					{
						key: 'project_demand_code',
						name: '需求编号',
					},
					{
						key: 'title',
						name: '需求名称',
					},
					{
						key: 'content',
						name: '需求内容',
					},
					{
						key: 'level',
						name: '需求级别',
					},
					{
						key: 'status',
						name: '需求状态',
					},
					{
						key: 'project_demand_type',
						name: '需求类型',
					},
					{
						key: 'project_id',
						name: '需求项目',
					},
					
					{
						key: 'member_id',
						name: '负责人',
					},
					{
						key: 'form_id',
						name: '需求模板',
					},
				],
				ReferenceTime1: [{
						key: 'start_time',
						name: '需求开始日期',
					},
					{
						key: 'plan_completion_time',
						name: '计划完成日期',
					},
				],
				// 任务
				Referencearr2: [
					{
						key: 'project_demand_code',
						name: '任务编号',
					},
					{
						key: 'title',
						name: '任务名称',
					},
					{
						key: 'content',
						name: '任务内容',
					},
					{
						key: 'level',
						name: '任务级别',
					},
					{
						key: 'status',
						name: '任务状态',
					},
					{
						key: 'project_demand_type',
						name: '任务类型',
					},
					{
						key: 'project_id',
						name: '任务项目',
					},
					
					{
						key: 'member_id',
						name: '负责人',
					},
					{
						key: 'form_id',
						name: '任务模板',
					},
				],
				ReferenceTime2: [{
						key: 'start_time',
						name: '任务开始日期',
					},
					{
						key: 'plan_completion_time',
						name: '计划完成日期',
					},
				],
				// 问题
				Referencearr3: [
					{
						key: 'project_demand_code',
						name: '问题编号',
					},
					{
						key: 'title',
						name: '问题名称',
					},
					{
						key: 'content',
						name: '问题内容',
					},
					{
						key: 'level',
						name: '问题级别',
					},
					{
						key: 'status',
						name: '问题状态',
					},
					{
						key: 'project_demand_type',
						name: '问题类型',
					},
					{
						key: 'project_id',
						name: '问题项目',
					},
					
					{
						key: 'member_id',
						name: '负责人',
					},
					{
						key: 'form_id',
						name: '问题模板',
					},
				],
				ReferenceTime3: [{
						key: 'start_time',
						name: '问题开始日期',
					},
					{
						key: 'plan_completion_time',
						name: '计划完成日期',
					},
				],
							
				
				
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import "../../css/projecticon.css";
	.cancelbtn{
		padding: 0 10px;
		cursor: pointer;
	}
	.type_txt{
		font-size: 11px;
		color:#909090;
	}
	.nodatxt{
		font-size: 14px;
		padding: 10px;
		color: #818181;
		text-align: center;
	}
	.workihead{
		margin-bottom: 15px;
		.addarea{
			.addbtn{
				i{
					color:rgba(144, 154, 170, 1);
					font-size: 16px;
					margin-right: 6px;
				}
				cursor: pointer;
				font-size: 14px;
				font-weight: 400;
				color: rgba(43, 117, 235, 1);
			}
		}
	}  
	.workiaddlist{
		.add_item{
			border-bottom:solid 1px rgba(237, 241, 244, 1);
			padding: 8px 0;
			.type_box{
				width: 81px;
				height: 32px;
				border-radius: 3px;
				border: 1px solid rgba(237, 241, 244, 1);
				.icon{
					width: 14px;
					height: 14px;
					img{
						width: 100%;
						height: 100%;
					}
					margin-right: 11px;
				}
				.txt{
					font-size: 14px;
					font-weight: 400;
					color: rgba(46, 64, 94, 1);
				}
			}
			.search_create_box{
				margin: 0 9px;
				position: relative;
				width: 440px;
				.search_input{
					position: relative;
					width: 100%;
					/deep/ .el-input{
						width: 100%;
						
					}
					i{
						
						font-size: 14px;
					}
					.dclearable:hover{
						i{
							color: red;
						}
					}
					.dclearable{
						cursor: pointer;
						right: 40px;
						position: absolute;
						z-index: 20000;
					}
					.dropdown.isdown{
						transform: rotate(180deg);
					}
					.dropdown{
						transition: all .3s;
						right: 15px;
						position: absolute;
					}
				}
				.search_resbox{
					position: absolute;
					top: 105%;
					left: 0;
					width: 100%;
					z-index: 10;
					
					max-height: 230px;
					overflow: auto;
					background-color: #fff;
					box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 15px;
					// box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
					
					.res_item:hover{
						// background-color:rgb(245,246,248);
						background-color: #eee;
					}
					.res_item.isActive{
						background: #E9F2FE;
						.title{
							color: var(--themeColors);
						}
					}
					.res_item{
						padding: 10px;
						cursor: pointer;
						.code{
							font-size: 10px;
							padding: 5px;
							border-radius: 3px;
							background: rgba(245, 246, 248, 1);
							margin-right: 10px;
						}
						.title{
							color: rgba(46, 64, 94, 1);
							font-size: 12px;
							max-width: 300px;
						}
						
					}
				}
			}
		
		}
	}
			 
			
				  
					    
	
	.member_select{
		/deep/ .el-select{
			width: 220px;
		}
	}
	
	.operate_box{
		/deep/ .el-button{
			border-radius: 3px !important;
			border: none !important;
			width: 80px;
			height: 32px;
			line-height: 0;
		}
		.create{
			margin-left: 10px;
			background: rgba(43, 117, 235, 1);
			color:#fff;
		}
		.close{
			margin-left: 4px;
			background: rgba(255, 255, 255, 1);
		}
	}  
	
	.worki_content{
		margin-bottom: 30px;
		width: 100%;
		.worki_line:hover{
			background-color: rgba(249, 249, 249, 1);
		}
		.worki_line{
			width: 100%;
			height: 44px;
			padding: 0 9px;
			padding-right: 30px;
			
			border-bottom:solid 1px rgba(237, 241, 244, 1);
			.detail_links {
				.icon {
					width: 14px;
					height: 14px;
			
					img {
						width: 100%;
						height: 100%;
					}
				}
			
				.links_txt {
					cursor: pointer;
					min-width: 60px;
					padding: 0 5px;
					height: 20px;
					font-size: 12px;
					margin-left: 5px;
					border-radius: 3px;
					background: rgba(245, 246, 248, 1);
				}
			}
		}
		.worki_val{
			flex: 1;
			
			margin: 0 15px ;
			.ctxt{
				max-width: 450px;
				font-size: 14px;
				font-weight: 400;
				color: rgba(46, 64, 94, 1);
			}
		}
		.member_area {
			min-width: 65px;
			.icon_box{
				width: 16px;
				height: 16px;
				background-color: var(--themeColors);
				border-radius: 100%;
				margin-right: 3px;
				i {
					color: #fff;
					font-size: 9px;
				}
			}
			.txt {
				font-size: 14px;
				font-weight: 400;
				color: rgba(46, 64, 94, 1);
				max-width: 300px;
			}
		}
		
		
	}
		     
		
	
	
</style>